import './config';
import React from 'react';
import PropTypes from 'prop-types';
import { AuthenticateUser } from './AuthenticateUser';

export const Widget = (props) => {
  return <AuthenticateUser {...props} />;
};

Widget.displayName = 'utility/AuthenticateUser';

Widget.propTypes = {
  data: PropTypes.shape({
    userDetails: PropTypes.bool,
  }),
  events: PropTypes.shape({
    onSuccess: PropTypes.func,
    onError: PropTypes.func,
  }),
};

Widget.defaultProps = {
  data: null,
  events: null,
};
